import React from 'react';
import '../../styles/dashboard/FeatureSwitch.css';

export default function FeatureSwitch({ enabled, handleClick }) {
    return (
        <div className="FeatureSwitch">
            <button 
            className={`on-button ${enabled ? 'selected' : 'not-selected'}`}
            onClick={(e) => {
                if (!enabled) {
                    handleClick();
                }
            }}>
                ON
            </button>
            <button 
            className={`off-button ${enabled ? 'not-selected' : 'selected'}`}
            onClick={(e) => {
                if (enabled) {
                    handleClick();
                }
            }}>
                OFF
            </button>
        </div>
    )
}